// extracted by extract-css-chunks-webpack-plugin
module.exports = {"Close":"Close_2XhIV_v16-5-1","Close__PositionAbsolute":"Close__PositionAbsolute_zliSI_v16-5-1"};